import content from "app-content";

const getCoreNonPrimaryFulfilmentStrings = ({
  source: { description: sourceDescription }
}) => {
  const { source_info_label } = content;

  return { source_info_label, sourceDescription };
};

export default getCoreNonPrimaryFulfilmentStrings;
